export const ACCEPTED = 'Accepted';
export const PENDING = 'Pending';
export const REJECTED = 'Rejected';


// WEBPACK FOOTER //
// ./src/constants/contact.constants.js